import {AxiosError} from 'axios';
import {TaskDetailsResponse} from 'web-library/models/Request';
import {GET_TASK_DETAILS_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_REQUEST_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: TaskDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetRequestOrTaskDetails = ({onSuccess, onError, uuid}: Input) => {
  const getTaskDetails = async () => {
    const res = await axiosClient.get<TaskDetailsResponse>(GET_REQUEST_URL(uuid));
    return res.data;
  };

  return useCustomQuery(GET_TASK_DETAILS_QUERY_KEY.concat(uuid), getTaskDetails, {
    onSuccess,
    onError,
  });
};
